import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

export const HEADER_ACTIONS_ID = "admin-page-actions";

/** Puts page buttons in the shell header, next to the title. */
export function PageHeaderActions({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useEffect(() => setTarget(document.getElementById(HEADER_ACTIONS_ID)), []);
  return target ? createPortal(children, target) : null;
}
